import { jsxs, jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box } from "@zillow/constellation-10";
import PropTypes from "prop-types";
import "react";
import { omitUndefined } from "../../utils/lodash.esm.js";
import CalculatorForm from "../CalculatorForm/CalculatorForm.esm.js";
import { FieldConfig, DEFAULT_VALUES_SHAPE } from "./DTICalculator.utils.esm.js";
import DTIFields from "./DTIFields.esm.js";
import DTIOutputTable from "./DTIOutputTable.esm.js";
const calculatorFormStyles = css({
  paddingBottom: "default",
  display: "flex",
  flexDirection: "column-reverse",
  "@media (min-width: 769px)": {
    flexDirection: "row",
    justifyContent: "space-between"
  }
});
const fieldsStyles = css({
  flexShrink: 0,
  "@media (min-width: 769px)": {
    flexBasis: "30%",
    marginRight: "default"
  }
});
const DTICalculator = ({
  defaultValues,
  editorMode
}) => /* @__PURE__ */ jsxs(CalculatorForm, { className: calculatorFormStyles, editorMode, fieldStorageKey: "DTIFields", calcTypeForMarketing: "DTI", defaultValues: {
  [FieldConfig.annualIncome.name]: 7e4,
  [FieldConfig.minCreditCardPayments.name]: 200,
  [FieldConfig.carLoanPayments.name]: 500,
  [FieldConfig.studentLoanPayments.name]: 300,
  [FieldConfig.alimonySupportPayments.name]: 0,
  [FieldConfig.secondaryHomeExpenses.name]: 0,
  [FieldConfig.otherDebtPayments.name]: 0,
  ...omitUndefined(defaultValues)
}, children: [
  /* @__PURE__ */ jsx(DTIFields, { className: fieldsStyles }),
  /* @__PURE__ */ jsx(Box, { css: {
    "@media (min-width: 769px)": {
      flexBasis: "65%"
    }
  }, children: /* @__PURE__ */ jsx(DTIOutputTable, {}) })
] });
DTICalculator.defaultProps = {
  defaultValues: void 0,
  editorMode: void 0
};
DTICalculator.propTypes = {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
};
export {
  DEFAULT_VALUES_SHAPE,
  DTICalculator as default
};
